export type Importer = {
    name: string,
    pathSegment: string,
    templateFileName: string,
};

export const IMPORTERS: Importer[] = [
    {name: 'zone-import', pathSegment: 'zone-import', templateFileName: 'plantilla-zonas.xlsx'},
    {name: 'city-fare-import', pathSegment: 'fare-import', templateFileName: 'plantilla-tarifas.xlsx'},
    {name: 'underground-fare-import', pathSegment: 'underground-fare-import', templateFileName: 'plantilla-tarifas-subterraneo.xlsx'},
    {name: 'authorization-import', pathSegment: 'authorization-import', templateFileName: 'plantilla-autorizaciones.xlsx'},
];

export const SUMMARY_LABELS: Record<string, string> = {
    rulesToCreate: 'Reglas que se crean',
    faresToCreate: 'Tarifas que se crean',
    authorizationsToCreate: 'Autorizaciones que se crean',
    zoneTypesToCreate: 'Tipos de zona que se crean',
    zonesToCreate: 'Zonas que se crean',
    existingToReplace: 'Registros actuales que se sustituyen',
    rulesCreated: 'Reglas creadas',
    faresCreated: 'Tarifas creadas',
    authorizationsCreated: 'Autorizaciones creadas',
    zoneTypesCreated: 'Tipos de zona creados',
    zonesCreated: 'Zonas creadas',
};
